import React, { Component } from "react";

class Title extends Component {
 	render() {
	    return (
			<div className="fram_cust full_width">
				<div className="container">
					<h1>Custom Picture Frames Online</h1>
				</div>
			</div>
	    );
  	}
}

export default Title;